/*******************************************************************************
  inputValidation.js

  Author: Advait;
*******************************************************************************/

/**
 * Validate email address format
 * @param {string} email - Email address to validate
 * @returns {boolean} - True if email is valid, false otherwise
 */
export const validateEmail = (email) => {
  if (!email || typeof email !== "string") {
    return false;
  }

  // RFC 5322 compliant email regex
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  return emailRegex.test(email.trim());
};

/**
 * Trim whitespace from string
 * @param {string} value - String to trim
 * @returns {string} - Trimmed string or empty string if input is invalid
 */
export const trimWhitespace = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value !== "string") {
    return String(value).trim();
  }
  return value.trim();
};
